<template>
  <main id="appointments-main">
    <div class="app-view-container">
      <el-row>
        <el-col class="app-view-title">
          {{ $t('customerCenter.appointments.title') }}
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <search-filter ref="searchFilter" />
        </el-col>
      </el-row>

      <el-row class="search-summary-container bg-white">
        <el-col>
          <el-row class="default-section-header" style="display: flex; align-items: center;">

            <el-col :span="10" class="default-section-title" style="display: flex; align-items: center;">
              <span>{{ $t('customerCenter.appointments.summaryTitle') }}</span>
              <el-tooltip class="item" effect="dark" :enterable="false" :content="$t('common.refresh')"
                placement="top-start">
                <el-button @click="handleRefresh" icon="el-icon-refresh" size="mini"
                  class="button-action-default search-summary-refresh-button" style="margin-left: 8px;" />
              </el-tooltip>
            </el-col>


            <el-col :span="7" class="totals-section"></el-col>

            <!-- Botón NEW -->
            <el-col :span="7" class="default-section-actions text-align-end"
              style="display: flex; align-items: center; justify-content: flex-end;">
              <download-csv />
              <span id="manage-shipment-more-actions-section">
                <add-appointment />
              </span>
            </el-col>
          </el-row>

          <el-row class="search-summary">
            <el-col>
              <section class="height-100-p">
                <search-summary-appointments ref="summaryList" />
              </section>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>


  </main>
</template>


<script>

import { mapGetters } from 'vuex';
import { APPOINTMENTS_SEARCH } from '@/store/actions';
import SearchFilter from './SearchFilter';
import AddAppointment from './components/addAppointment/AddAppointment';
import SearchSummaryAppointments from './SearchSummary';
import DownloadCsv from './components/downloadCsv/DownloadCsv';

export default {
  name: 'AppointmentsList',
  components: {
    SearchFilter,
    AddAppointment,
    SearchSummaryAppointments,
    DownloadCsv
  },
  data() {
    return {
      dialogVisible: false
    };
  },
  computed: {
    ...mapGetters([
      'appointments'
    ])
  },
  created() {
    // this.$store.dispatch('getAppointments');
    this.$store.dispatch(APPOINTMENTS_SEARCH);
  },
  methods: {
    handleRefresh() {
      this.$store.dispatch(APPOINTMENTS_SEARCH);
    },

  }
};
</script>
